import AuthUserContext, { withAuthentication } from './context';
import { isSponsor, isAdmin, isTeam } from './helpers';

export default AuthUserContext;
export { 
  withAuthentication,
  isSponsor,
  isTeam,
  isAdmin
};